import { closeCsatSurveyRpc as closeCsatSurveyRpcLegacy, shouldSendCsatSurveyRpc as shouldSendCsatSurveyRpcLegacy, submitCsatSurveyRpc as submitCsatSurveyRpcLegacy } from '../../../__generated__/chirp/com/hubspot/copilot/rpc/CopilotCsatService';
import { closeCsatSurveyRpc, shouldSendCsatSurveyRpc, submitCsatResponseRpc } from '../../../__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotCsatService';
import { rpcClient } from '../../http/rpcClient';
export const fetchShouldSendCsatSurvey = ({
  threadId
}) => {
  return rpcClient.call(shouldSendCsatSurveyRpc, {
    request: {
      threadId
    }
  });
};
export const sendSubmitCsatSurvey = ({
  score,
  text,
  threadId
}) => {
  return rpcClient.call(submitCsatResponseRpc, {
    request: {
      score,
      text,
      threadId
    }
  });
};
export const sendCloseCsatSurvey = ({
  threadId
}) => {
  return rpcClient.call(closeCsatSurveyRpc, {
    request: {
      threadId
    }
  });
};

// Legacy API

export const fetchShouldSendCsatSurveyLegacy = threadId => {
  return rpcClient.call(shouldSendCsatSurveyRpcLegacy, {
    request: {
      threadId
    }
  });
};
export const sendSubmitCsatSurveyLegacy = ({
  score,
  text,
  threadId
}) => {
  return rpcClient.call(submitCsatSurveyRpcLegacy, {
    request: {
      score,
      text,
      threadId
    }
  });
};
export const sendCloseCsatSurveyLegacy = () => {
  return rpcClient.call(closeCsatSurveyRpcLegacy, {
    request: {}
  });
};